let groupBy = function (array, key) {
    return array.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

export const setPrimaryPieData = (result) => {
    const table_data = result.data[0].report.table_data;
    const categories = groupBy(table_data, "categorized_status");
    const pieChartData = {
      name: "Task details",
      colorByPoint: true,
      data: [],
    };
    const arraylength = table_data.length;
    for (let key in categories) {
      let value = categories[key].length;
      // total_length[key] = value
      let temp = {};
      temp["name"] = temp["drilldown"] = key;
      temp["y"] = Math.floor((value / arraylength).toFixed(2) * 100);
      pieChartData["data"].push(temp);
    }

    const timestamptask = result.data[0].report.timestamp_task_details;
    const timestampextension = result.data[0].report.timestamp_task_extensions;
    const totalextension = result.data[0].report.total_extensions;
    const totaltasks = result.data[0].report.total_tasks;

    return [pieChartData, timestamptask, timestampextension, totalextension, totaltasks];
  };

  export const defaultDrilledPieData = (result) => {
    const table_data = result.data[0].report.table_data;
    const categories = groupBy(table_data, "ReturnStatus");
    const pieChartData = {
      name: "Task details",
      colorByPoint: true,
      data: [],
    };
    const arraylength = table_data.length;
    for (let key in categories) {
      let value = categories[key].length;
      // total_length[key] = value
      let temp = {};
      temp["name"] = temp["drilldown"] = key;
      temp["y"] = Math.floor((value / arraylength).toFixed(2) * 100);
      pieChartData["data"].push(temp);
    }
    return pieChartData;
  };

  export const extensionPieData = (result) => {
    const table_data = result.data[0].report.extensions;
    const pieChartData = {
      name: "Extension details",
      colorByPoint: true,
      data: [],
    };
    for (let key in table_data) {
      // total_length[key] = value
      let temp = {};
      temp["name"] = table_data[key].Status;
      temp["y"] = table_data[key].count;
      pieChartData["data"].push(temp);
    }
    return pieChartData;
  };

  export const updateDrilledPie = (drilled_element, apiResponse) => {
    console.log("UpdateDrilledPie apiresp", apiResponse)
    console.log("updatedrilledpie elem", drilled_element)
    const table_data = apiResponse.data[0].report.table_data;
    console.log("updatedrilledpie tabledata", table_data )
    const rowData = table_data.filter((obj) => {
      return obj.categorized_status == drilled_element;
    });
    console.log("updatedrilledpie rowData", rowData )
    const categories = groupBy(rowData, "ReturnStatus");
    const drilledSeries = {
      name: "Drilled details",
      colorByPoint: true,
      data: [],
    };
    const arraylength = rowData.length;

    for (let key in categories) {
      let value = categories[key].length;
      let temp = {};
      temp["name"] = temp["drilldown"] = key;
      temp["y"] = Math.floor((value / arraylength).toFixed(2) * 100);
      drilledSeries["data"].push(temp);
    }
    console.log("updatedrilledpie func data", drilledSeries)
    return [rowData, drilledSeries];
  }